import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavbarService } from './navbar.service';

@Injectable({
    providedIn: 'root'
})
export class PhoenixSupportService {
    constructor(private router: Router, private navBarService: NavbarService) { }

    phoenixPageUrls: string[] = ['bring-your-own-phone']
    /**
     * Authenticated state is lost when navigating b/w phoenix and angular
     * Method to retrigger the authentication flow when
     * User is logged in but Angular doesnt have the logged in state
     */
    retriggerAuthFlowForHandoff(sourceRoute: string): void {
        if (this.checkIfUserIsLoggedIn() && !this.navBarService.isLoggedIn()) {
            const auth: string = 'auth';
            const navParams = {
                path: auth,
                lang: window.location.href.includes('es') ? 'es' : '',
            };
            sessionStorage.setItem('phoenixHandOffSourceRoute', sourceRoute);
            document.cookie = "tpp_id_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=t-mobile.com";
            setTimeout(() => {
                this.router.navigate([auth, navParams]);
            },500);
            
        }
    }

    checkIfUserIsLoggedIn(): boolean {
        const loginCookieFound = document.cookie.match(new RegExp(`${'tpp_id_token'}=([^;]+)`));
        return !!(loginCookieFound !== null && loginCookieFound[1]);
    }

    /**
     * Authenticated state is lost when navigating b/w phoenix and angular
     * checking if user navigated from Phoenix page , if so , re-triggering the authentication flow
     * to ensure the user is logged in and Angular has the logged in state
     * also ensuring to return back to the page that triggers the authentication flow
     */
    checkAndHandleNavHandoff(sourceRoute: string): void {
        const phoenixPage = this.phoenixPageUrls.find((url) => document.referrer?.includes(url));
        if (phoenixPage) {
            this.retriggerAuthFlowForHandoff(sourceRoute);
        }
    }
}